<div *ngIf="isTopWindow">
  <ssab-cx-storefront></ssab-cx-storefront>
</div>
<div class="cx-spinner modal fade" id="ssab-spinner">
  <div class="modal-dialog" role="document">
    <cx-spinner></cx-spinner>
  </div>
</div>
